import Api from '../Api';

export const getVendors = () => async dispatch => {
  const { data } = await Api.get('/vendors');
  dispatch({
    type: 'FETCH_VENDORS',
    payload: data,
  });
};

export const clearVendors = () => {
  return {
    type: 'CLEAR_VENDORS',
  };
};

export const getVendor = id => async dispatch => {
  const { data } = await Api.get(`/vendors/${id}`);
  dispatch({
    type: 'FETCH_VENDOR',
    payload: data,
  });
};

export const clearVendor = () => {
  return {
    type: 'CLEAR_VENDOR',
  };
};

export const getVendorIds = () => async dispatch => {
  const { data } = await Api.get('/vendors/ids');
  dispatch({
    type: 'FETCH_VENDOR_IDS',
    payload: data,
  });
};

export const clearVendorIds = () => {
  return {
    type: 'CLEAR_VENDOR_IDS',
  };
};
